import { useUser } from "../../api/auth/AuthSelector";
import { AuthGuardProps } from "./Guard.types";
import ResetGuard from "./ResetGuard";

export default function ReverseAuthGuard({ children }: AuthGuardProps) {
  const user = useUser();
  return user ? <ResetGuard to="main" /> : children;
}
